import Modal from '@mui/material/Modal';
import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
// import Modal from '@mui/material/Modal';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};
export default function CssfrmMod() {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div>
      <Button onClick={handleOpen} style={{color:'teal'}}>Introduction to CSS Framework</Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        
      >
        <Box sx={style} height={300} width={300} style={{'background':'aquamarine'}}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Introduction to CSS Framework.
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
          Pre-built libraries of CSS code that provide common styling conventions, reusable components, 
          and responsive layout tools to streamline web development.<br/>
Offer a structured approach to styling, promoting consistency and efficiency.<br/>
Help developers create visually appealing and user-friendly websites quickly and easily.<br/>

          </Typography>
        </Box>
      </Modal>
    </div>
  );
}